import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "step-box mg-b-20" }
const _hoisted_2 = { class: "step-1" }
const _hoisted_3 = { class: "step-2" }
const _hoisted_4 = { class: "step-3" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-jc-c"
}
const _hoisted_6 = {
  key: 1,
  class: "flex flex-jc-c"
}
const _hoisted_7 = {
  key: 2,
  class: "flex flex-jc-c"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_step1 = _resolveComponent("step1")!
  const _component_step2 = _resolveComponent("step2")!
  const _component_step3 = _resolveComponent("step3")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "",
      width: "900px",
      "align-center": "",
      "before-close": _ctx.handleClose
    }, {
      title: _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "bold fs-20 flex flex-jc-c" }, " 导入薪资表 ", -1)
      ])),
      footer: _withCtx(() => [
        (_ctx.activeStep === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.activeStep === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeStep = 1))
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("返回上一步")
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeStep === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("返回列表")
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_steps, { active: _ctx.activeStep }, {
            default: _withCtx(() => [
              _createVNode(_component_el_step, {
                title: "上传文件",
                description: "上传填好的信息表"
              }),
              _createVNode(_component_el_step, {
                title: "确认信息",
                description: "匹配导入信息"
              }),
              _createVNode(_component_el_step, {
                title: "查看结果",
                description: "导入成功"
              })
            ]),
            _: 1
          }, 8, ["active"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(_component_step1, {
            ref: "step1",
            onUploadData: _ctx.handleStep
          }, null, 8, ["onUploadData"])
        ], 512), [
          [_vShow, _ctx.activeStep === 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createVNode(_component_step2, { "error-list": _ctx.errorList }, null, 8, ["error-list"])
        ], 512), [
          [_vShow, _ctx.activeStep === 2]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createVNode(_component_step3)
        ], 512), [
          [_vShow, _ctx.activeStep === 3]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}